<template>
  <el-dialog title="详情"
             :visible.sync="detailShow"
             v-dialogDrag>
    <el-row>
      <el-col :span="8">
        <label>任务名称：</label>
        <span class="info-value ell"
              :title="detailInfo.planName">{{detailInfo.planName}}</span>
      </el-col>
      <el-col :span="8">
        <label>巡检周期：</label>
        <span class="info-value">{{detailInfo.planCycle}}</span>
      </el-col>
      <el-col :span="8">
        <label>开始时间：</label>
        <span class="info-value">{{detailInfo.startTime}}</span>
      </el-col>
    </el-row>
    <el-row class="info-row">
      <el-col :span="8">
        <label>截止时间：</label>
        <span class="info-value">{{detailInfo.endTime}}</span>
      </el-col>
      <el-col :span="8">
        <label>计划状态：</label>
        <span class="info-value">{{status[detailInfo.status]}}</span>
      </el-col>
      <el-col :span="8">
        <label>巡检人员：</label>
        <span class="info-value">{{detailInfo.inspectPersonList}}</span>
      </el-col>
    </el-row>
    <el-row class="info-row">
      <el-col :span="8">
        <label>巡检范围：</label>
        <span class="info-value">{{detailInfo.areaList && detailInfo.areaList.toString()}}</span>
      </el-col>
    </el-row>
    <div class="info-row detail_list">
      <h4 class="info-title">巡检内容</h4>
      <ioc-table ref="crud"
                 v-model="detailList"
                 :data="detailData"
                 :option="option"
                 :page="{}"
                 class="table-box">
      </ioc-table>
    </div>
  </el-dialog>
</template>

<script>
import { api } from "../api";
import utils from '@src/common/utils'
import tableOption from '../const/detailOption'
export default {
  props: {
  },
  data () {
    return {
      detailInfo: {},
      detailShow: false,
      detailList: {},
      detailData: [],
      option: tableOption(this),
      status: {
        '1': '待巡检',
        '2': '执行中',
        '3': '已完成',
        '4': '超时'
      }
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    open (detailInfo) {
      this.detailShow = true
      const nameList = []
      if (detailInfo.inspectPersonList && detailInfo.inspectPersonList.length) {
        detailInfo.inspectPersonList.map(item => {
          nameList.push(item.nickName)
        })
      }
      // detailInfo.inspectPersonList = nameList.toString()
      this.detailInfo = JSON.parse(JSON.stringify(detailInfo))
      this.detailInfo.inspectPersonList = nameList.toString()
      if (detailInfo) {
        this.getDetailList()
      }
    },
    getDetailList () {
      const params = {
        planCode: this.detailInfo.planCode
      }
      this.$fetch(api.inspectionPlan.queryInspectionPlanDetail, params).then(res => {
        if (res && res.success) {
          this.detailInfo.areaList = res.returnObj.areaList.map(item => {
            return item.areaName
          })
          this.detailData = (res.returnObj.fireassetTypeList || [])
          console.log('detailData', this.detailData)
        } else {
          this.$message.error(res.msgContent)
        }
      })
    }
  }
}
</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
@import "../style/inspectionPlan.scss";
.info-row {
  margin-top: 15px;
}

.info-title,
.info-value {
  @include set_theme_color(color, font-default-color);
}
.info-value {
  width: 150px;
  display: inline-block;
  vertical-align: top;
}
.table-box {
  height: 150px;
  overflow-y: auto;
}
</style>
